import * as React from 'react';
import {connect} from 'react-redux';
import * as HistoryModule from 'Modules/HistoryModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as NotificationModule from 'Modules/NotificationModule';
import {withTranslation} from 'react-i18next';
import SearchRidesForm from './../../../Layout/Form/SearchRidesForm';
import {createSerachQuery} from 'Connectors/_main';
import moment from 'moment';
import {submit} from 'redux-form';
import * as MapModule from "Modules/MapModule";
import HistoryRideDetails from "../Components/HistoryRideDetails.Component";
import HistoryRidesHeading from "../Components/HistoryRidesHeading.Component";
import HistoryRideElement from "../Components/HistoryRideElement.Component";

type Props = {
    title?: string;
    disabled?: boolean;
    zone?: HistoryModule.EnumTypes.CarDetailsViewType;
};

type ConnectedProps = {
    historyStore: HistoryModule.Types.HistoryStore;
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    activeNotification: NotificationModule.Types.NotificationDto;
    searchRidesFormSubmitSucceeded: boolean;
};
type DispatchedProps = {
    getCarRideDetails: Function;
    getCarRidesHistory: Function;
    setActiveRideViewType: Function;
    setMapCenter: Function;
    submitRidesForm: () => void;
    clearRideDetails: () => void;
};

type TranslateProps = {
    t: Function;
};
type State = {
    currentCarIdRidesResults: number;
};

class History extends React.Component<Props & ConnectedProps & DispatchedProps & TranslateProps, State> {
    constructor(props: Props & ConnectedProps & DispatchedProps & TranslateProps) {
        super(props);
        this.state = {
            currentCarIdRidesResults: null
        };
        this.initCarDetails = this.initCarDetails.bind(this);
        this.searchRidesSummary = this.searchRidesSummary.bind(this);
        this.manageNotificationUpdate = this.manageNotificationUpdate.bind(this);
    }

    public async initCarDetails(carRideId: number, listIndex: number) {
        const {getCarRideDetails, setActiveRideViewType, setMapCenter} = this.props;
        await getCarRideDetails(carRideId, listIndex);
        setActiveRideViewType(HistoryModule.EnumTypes.RideViewType.DETAILS);

        // poniżej centrowanie na samochodzie (teraz ma być boundsowanie na trasie)
        // try {
        //     const pathStart = this.props.historyStore.carRideDetails.path[0];
        //     setMapCenter({lat: pathStart.latitude, lng: pathStart.longitude});
        // } catch (e) {
        //     console.log(e);
        // }
    }

    public async searchRidesSummary(formData: { carId?: number, ignoreShorterThanKilometers?: any, dateRange: { endDate: moment.Moment, startDate: moment.Moment } }) {
        const {setActiveRideViewType} = this.props;

        const formTemp = {...formData};
        formTemp.carId = this.props.vehiclesStore.singleCarViewData.car.id;
        formTemp.dateRange.startDate = formTemp.dateRange.startDate.clone().startOf('day');
        formTemp.dateRange.endDate = formTemp.dateRange.endDate.clone().set({
            hour: 23,
            minute: 59,
            second: 0,
            millisecond: 0
        });
        if (typeof formTemp.ignoreShorterThanKilometers !== 'undefined') {
            formTemp.ignoreShorterThanKilometers = parseFloat(formTemp.ignoreShorterThanKilometers);
        }
        const serachQuery = createSerachQuery({...formTemp});

        await this.props.getCarRidesHistory(serachQuery);

        this.setState({
            currentCarIdRidesResults: this.props.vehiclesStore.singleCarViewData.car.id
        });
        setActiveRideViewType(HistoryModule.EnumTypes.RideViewType.LIST);
    }

    private manageNotificationUpdate() {
        this.setState(
            {
                currentCarIdRidesResults: this.props.vehiclesStore.singleCarViewData.car.id
            },
            () => {
                this.searchRidesSummary({
                    dateRange: {
                        startDate: moment(this.props.activeNotification.dataframe.dateTime).startOf('day'),
                        endDate: moment(this.props.activeNotification.dataframe.dateTime).endOf('day')
                    }
                });
            }
        );
    }

    public componentDidMount() {
        if (this.props.activeNotification) {
            this.manageNotificationUpdate();
        }
    }

    public componentDidUpdate(prevProps: Props & ConnectedProps & DispatchedProps & TranslateProps) {
        if (this.props.activeNotification && this.props.activeNotification.id !== prevProps.activeNotification.id) {
            this.manageNotificationUpdate();
        }
    }

    public render() {
        const {
          t,
          vehiclesStore,
          historyStore,
          viewManagementStore,
          setActiveRideViewType, setMapCenter,
          searchRidesFormSubmitSucceeded
        } = this.props;
        const initialValues = this.props.activeNotification
            ? {
                dateRange: {
                    startDate: moment(this.props.activeNotification.dataframe.dateTime).startOf('day'),
                    endDate: moment(this.props.activeNotification.dataframe.dateTime).endOf('day')
                }
            }
            : {};
        return (
            <div className="ride-history">
                {viewManagementStore.activeRideView === HistoryModule.EnumTypes.RideViewType.DETAILS && historyStore.carRideDetails !== null ? (
                    <HistoryRideDetails
                        rideDetails={historyStore.carRideDetails}
                        onClick={() => {
                            // po kliknięciu w < historia pojazdu wraca do spisu zafiltrowanych tras.
                            setActiveRideViewType(HistoryModule.EnumTypes.RideViewType.LIST);
                            // setMapCenter({lat: vehiclesStore.activeVehicleDetails.latestDataframe.latitude, lng: vehiclesStore.activeVehicleDetails.latestDataframe.longitude});
                            this.props.clearRideDetails()
                        }}
                        carDetails={vehiclesStore.singleCarViewData?.car}
                    />
                ) : (
                    <>
                        <div className="ride-history__element">
                            <SearchRidesForm onSubmit={this.searchRidesSummary} initialValues={initialValues}/>
                        </div>
                        {(searchRidesFormSubmitSucceeded || historyStore.carRidesHistorySummary) && <>
                            {historyStore.carRidesHistorySummary && <HistoryRidesHeading
                                totalDurationSeconds={historyStore.carRidesHistorySummary.totalDurationSeconds}
                                totalDistanceKilometers={historyStore.carRidesHistorySummary.totalDistanceKilometers}
                            />}
                            <div className="ride-history__list">
                                {historyStore.carRidesHistorySummary?.rides.length > 0
                                    ? historyStore.carRidesHistorySummary.rides.map((e, i) => (
                                        <HistoryRideElement
                                            key={`history_element_ride-${i}`}
                                            ride={e}
                                            parking={historyStore.carRidesHistorySummary.parkings[i]}
                                            onClick={() => this.initCarDetails(e.id, i)}
                                            error={historyStore.activeCarRideId === e.id && !historyStore.carRideDetails}
                                        />
                                    )) : (
                                        <div className="carDetailsComposite__element">
                                          <p>{t('noRidesForGivenPeriod')}</p>
                                        </div>
                                    )
                                }
                            </div>
                        </>}
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        historyStore: state.historyStore,
        vehiclesStore: state.vehiclesStore,
        viewManagementStore: state.viewManagementStore,
        activeNotification: state.notificationStore.activeNotification,
        searchRidesFormSubmitSucceeded: state.form?.searchRidesForm?.submitSucceeded
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        getCarRideDetails: (carRideId: number, listIndex: number) => dispatch(HistoryModule.Actions.getCarRideDetails(carRideId, listIndex)),
        getCarRidesHistory: (searchForRideData: URLSearchParams) => dispatch(HistoryModule.Actions.getCarRidesHistory(searchForRideData)),
        setActiveRideViewType: (activeRideViewType: HistoryModule.EnumTypes.RideViewType) => dispatch(ViewManagementModule.Actions.SetActiveRideViewType(activeRideViewType)),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center)),
        submitRidesForm: () => dispatch(submit('searchRidesForm')),
        clearRideDetails: () => dispatch(HistoryModule.Actions.clearRideDetails()),
    };
}

export default withTranslation('carDetails')(
    connect<{}, {}, Props>(
        mapStateToProps,
        mapDispachToProps
    )(History) as React.ComponentType<any>
) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Composites/History.tsx